var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFacebookFSvg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Social icon",
    clipPath: "url(#clip0_5720_106716)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M24 12.9517C24 6.32424 18.6274 0.95166 12 0.95166C5.37258 0.95166 0 6.32424 0 12.9517C0 18.9411 4.3882 23.9056 10.125 24.8059V16.4204H7.07812V12.9517H10.125V10.3079C10.125 7.30041 11.9166 5.63916 14.6576 5.63916C15.9701 5.63916 17.3438 5.87354 17.3438 5.87354V8.82666H15.8306C14.34 8.82666 13.875 9.75174 13.875 10.7017V12.9517H17.2031L16.6711 16.4204H13.875V24.8059C19.6118 23.9056 24 18.9411 24 12.9517Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5720_106716"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.95166)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookFSvg);
export default __webpack_public_path__ + "static/media/FacebookFSvg.4a46e29ee138b7a36a03c89ea8b1a233.svg";
export { ForwardRef as ReactComponent };